<script setup lang="ts">
import { computed } from 'vue';
import CopyButton from '@/components/aml-review/CopyButton.vue';
import { useSettingsStore } from '@/stores/settings.store';
import { toLocalIsoString } from '@/util/datetime';

const props = defineProps<{ value: string }>();

const settingsStore = useSettingsStore();

const utcIso = computed(() => new Date(props.value).toISOString());
const localIso = computed(() => toLocalIsoString(props.value));

// The form the account menu's Local dates checkbox chose; the other stays on hover.
const shown = computed(() =>
  settingsStore.localDates
    ? { value: localIso.value, other: utcIso.value, label: 'local timestamp' }
    : { value: utcIso.value, other: localIso.value, label: 'UTC timestamp' }
);
</script>

<template>
  <span class="flex min-w-0 items-center gap-1.5 font-mono text-xs text-gray-500">
    <span class="truncate" :title="shown.other" data-test="timestamp-iso">{{ shown.value }}</span>
    <CopyButton :value="shown.value" :label="shown.label" />
  </span>
</template>
